var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.00001C14.5 11.3137 11.8137 14 8.50001 14C7.47173 14 6.50384 13.7413 5.6579 13.2855C4.47796 12.6497 3.68397 13.2408 2.98374 13.3468C2.87752 13.3629 2.77173 13.3244 2.69577 13.2484C2.58047 13.1331 2.55852 12.9548 2.62221 12.8047C2.89704 12.1569 3.14939 10.9294 2.80531 9.89475C2.60724 9.29917 2.5 8.66209 2.5 8.00001C2.5 4.68629 5.18629 2 8.50001 2C11.8137 2 14.5 4.68629 14.5 8.00001Z",
    fill: "white",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3948 7.68379C10.3948 7.68379 8.99929 5.78907 8.50003 5.78906C8.0007 5.78906 6.60529 7.68379 6.60529 7.68379M8.50003 6.10485V10.2101V6.10485Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3948 7.68379C10.3948 7.68379 8.99929 5.78907 8.50003 5.78906C8.0007 5.78906 6.60529 7.68379 6.60529 7.68379M8.50003 6.10485V10.2101",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIc);
export default __webpack_public_path__ + "static/media/request_ic.e0a7f856471f1a854c07ae4f4c2a5162.svg";
export { ForwardRef as ReactComponent };